import {AbstractNegotiationStarter} from "@/modules/diplomacy/services/AbstractNegotiationStarter";
import {injectable} from "inversify";
import {Negotiation} from "@/modules/diplomacy/entity";
import {PlayerContractNegotiation, Team} from "@/modules/team/entity";
import PlayerContractNegotiationContainer from "@/modules/team/services/PlayerContractNegotiationContainer";
import {CanStartNegotiateInterface} from "@/modules/diplomacy/interfaces";
import {NegotiationStatusEnum} from "@/modules/diplomacy/enums";

@injectable()
export class PlayerContractNegotiationStarter extends AbstractNegotiationStarter {
  protected make(container: PlayerContractNegotiationContainer): Negotiation {
    const n = new PlayerContractNegotiation();
    n.target = container.player;
    n.years = container.years;
    n.playerTargetYears = container.playerTargetYears;

    return n;
  }

  public async getNegotiation(team: Team, target: CanStartNegotiateInterface) {
    return await PlayerContractNegotiation
      .createQueryBuilder('n')
      .innerJoinAndSelect('n.target', 'player')
      .innerJoinAndSelect('n.team', 'team')
      .where('player.id = :playerId', {playerId: target.id})
      .andWhere('n.status = :status', {status: NegotiationStatusEnum.OPENED})
      .andWhere('n.team = :teamId', {teamId: team.id})
      .getOne();
  }
}